/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { BUSINESS_LINES_TABS } from 'containers/pricing/common/settings'

export type PersistentLateFeesState = {
  hideArchived: boolean
  businessLine: string
}

const initialState: PersistentLateFeesState = {
  hideArchived: false,
  businessLine: BUSINESS_LINES_TABS.ALL_BUSINESS_LINES,
}

const lateFeesSlice = createSlice({
  name: 'persistentLateFees',
  initialState: { ...initialState },
  reducers: {
    setHideArchivedLateFees: (state, action: PayloadAction<boolean>) => {
      state.hideArchived = action.payload
    },
    setSelectedLateFeesBusinessLine: (state, action: PayloadAction<string>) => {
      state.businessLine = action.payload
    },
  },
})

export const { setHideArchivedLateFees, setSelectedLateFeesBusinessLine } = lateFeesSlice.actions

type WithLateFeesState = { persistentLateFees?: PersistentLateFeesState }

export const selectHideArchivedLateFees = (state: WithLateFeesState): boolean | undefined => state.persistentLateFees?.hideArchived

export const selectSelectedLateFeesBusinessLine = (state: WithLateFeesState): string =>
  state.persistentLateFees?.businessLine ?? BUSINESS_LINES_TABS.ALL_BUSINESS_LINES

export default lateFeesSlice.reducer
